import routerOptions0 from "/builds/uroweb/uroweb-frontend/node_modules/.pnpm/nuxt@3.19.3_@parcel+watcher@2.5.1_@types+node@20.19.19_@vue+compiler-sfc@3.5.22_db0@0.3.4_esl_wi67uvacl5vqcjjnu5jp3xc6my/node_modules/nuxt/dist/pages/runtime/router.options.js";
const configRouterOptions = {
  hashMode: false,
  scrollBehaviorType: "auto"
}
export const hashMode = false
export default {
...configRouterOptions,
...routerOptions0,
}